import React, { useEffect, useState } from 'react'
import '../../css/case.scss'
import moment from 'moment'
import { Row, Input, Button, Typography, DatePicker, Col, Progress } from 'antd'
const { Text } = Typography
const { TextArea } = Input

const WorkLog = ({
  savetimeTracking,
  actionCase,
  showCaseModal,
  workLog,
  editWorkLog,
}) => {
  const [timeInput, setTimeInput] = useState({
    createdAt: null,
    hrs: 0,
    workDescription: null,
    mins: 0,
  })
  const [inputValue, setInputValue] = useState('')
  const [prevValidInput, setPrevValidInput] = useState({
    hours: 0,
    minutes: 0,
  })

  useEffect(() => {
    if (!actionCase || !actionCase.totalTimeSpent) return
    const hrs = Math.floor(actionCase.totalTimeSpent / 60)
    const mins = actionCase.totalTimeSpent % 60

    setTimeInput((prevState) => ({
      ...prevState,
      hrs: timeInput.hrs + hrs,
      mins: timeInput.mins + mins,
    }))
    return () => {
      console.log('Unmounting State')
      setTimeInput({ createdAt: null, hrs: 0, workDescription: null, mins: 0 })
      setPrevValidInput({ hours: 0, minutes: 0 })
      setInputValue('')
    }
  }, [actionCase])

  useEffect(() => {
    console.log('LLO', workLog)
    if (workLog != null) {
      var hrs = Math.floor(workLog.timeMin / 60)
      var day = 0
      var mins = 0
      if (hrs >= 24) {
        day = Math.floor(hrs / 24)
        hrs = hrs % 24
      } else mins = workLog.timeMin % 60
      setTimeInput({
        createdAt: moment(workLog?.createdAt).utc() || null,
        hrs: hrs || 0,
        workDescription: workLog?.workDescription,
        mins: mins || 0,
      })
      setPrevValidInput({ hours: hrs, minutes: mins })
      var inputvalue = ''
      if (day > 0) {
        if (hrs == 0) inputvalue = day + 'd'
        else inputvalue = (day + hrs / 24).toFixed(2) + 'd'
      } else if (hrs > 0) {
        if (mins == 0) inputvalue = hrs + 'h'
        else inputvalue = (hrs + mins / 60).toFixed(2) + 'h'
      } else {
        inputvalue = mins + 'm'
      }
      setInputValue(inputvalue)
    }
  }, [workLog])

  const convertToHoursAndMinutes = (input) => {
    const timePattern = /^(\d*\.?\d+)([dhm]?)$/
    const match = input.match(timePattern)
    if (!match) {
      return { hours: 0, minutes: 0 }
    }
    const value = parseFloat(match[1])
    const unit = match[2]

    let hours = 0
    let minutes = 0

    switch (unit) {
      case 'd':
        hours = value * 24
        break
      case 'h':
        hours = value
        break
      case 'm':
        minutes = value
        break
      default:
        hours = value
        break
    }
    if (hours % 1 !== 0) {
      //Not whole number
      const fractionalHours = hours % 1
      hours = Math.floor(hours)
      minutes += fractionalHours * 60
    }
    return { hours, minutes: Math.round(minutes) }
  }

  const handleInputChange = (e) => {
    const value = e.target.value
    setInputValue(value)
    const { hours: newHours, minutes: newMinutes } =
      convertToHoursAndMinutes(value)
    if (/^\d*\.?\d+[dhm]?$/.test(value)) {
      // Subtract the previous valid input
      setTimeInput((prevState) => ({
        ...prevState,
        hrs: prevState.hrs - prevValidInput.hours + newHours,
        mins: prevState.mins - prevValidInput.minutes + newMinutes,
      }))

      // Update the previous valid input
      setPrevValidInput({ hours: newHours, minutes: newMinutes })
    } else {
      // Reset the cumulative time if the input is invalid
      setTimeInput((prevState) => ({
        ...prevState,
        hrs: prevState.hrs - prevValidInput.hours,
        mins: prevState.mins - prevValidInput.minutes,
      }))

      // Clear the previous valid input
      setPrevValidInput({ hours: 0, minutes: 0 })
    }
  }

  const handleSave = () => {
    if (!isValidInput() && workLog == null) return
    // console.log("LLP",{...timeInput,createdAt:timeInput.createdAt._i,hrs:0,mins:prevValidInput.minutes+prevValidInput.hours*60,wlid:workLog?.wlid,caseId:workLog?.caseId})
    workLog == null
      ? savetimeTracking(convertToHoursAndMinutes(inputValue), {
          ...timeInput,
          hrs: 0,
          mins: prevValidInput.minutes + prevValidInput.hours * 60,
        })
      : editWorkLog({
          ...timeInput,
          createdAt: timeInput.createdAt,
          hrs: 0,
          mins: prevValidInput.minutes + prevValidInput.hours * 60,
          wlid: workLog?.wlid,
          caseId: workLog?.caseId,
        })
    showCaseModal()
  }

  const isValidInput = () => {
    return (
      inputValue.trim() !== '' &&
      timeInput.createdAt !== null &&
      timeInput.hrs * 60 + timeInput.mins > 0 &&
      timeInput.createdAt < moment()
    )
  }
  return (
    <Row>
      <Text className=' text-bold'>WORK LOG</Text>
      <Progress
        type='line'
        percent={100}
        strokeColor='blue'
        strokeWidth={15}
        showInfo={false}
        className='vertical-progress-bar'
      />
      <Text className='timetracking-fit'>
        {`${timeInput.hrs} hours ${timeInput.mins ? timeInput.mins + ' minutes ' : ''}`}{' '}
        Logged
      </Text>

      <Text className='timetracking-fit text-bold'>
        Time Spent: <Text className='required-input-color'>*</Text>
      </Text>
      <Input
        type='text'
        placeholder='Enter time (e.g., 60m, 3d, 4h)'
        value={inputValue}
        onChange={handleInputChange}
      />

      <Text className=' text-bold'>Use the format:(4d 6h 3m)</Text>
      <Row className='timetracking-fit'>
        <ul>
          <li>d=days</li>
          <li>h=hours</li>
          <li>m=minutes</li>
        </ul>
      </Row>

      <Text className='text-bold timetracking-fit'>
        Date Started: <Text className='required-input-color'>*</Text>
      </Text>
      <DatePicker
        showTime
        format='MM/DD/YYYY HH:mm'
        value={timeInput.createdAt}
        onChange={(value) => setTimeInput({ ...timeInput, createdAt: value })}
        placeholder='Select Date and Time'
        className='timetracking-fit'
        disabledDate={(current) => {
          let customDate = moment().add(1, 'd').format('MM/DD/YYYY')
          return current && current >= moment(customDate, 'MM/DD/YYYY')
        }}
      />

      <Text className='text-bold timetracking-fit'> Work Description:</Text>
      <TextArea
        autoSize={{ minRows: 5, maxRows: 15 }}
        value={timeInput.workDescription}
        onChange={(e) =>
          setTimeInput({ ...timeInput, workDescription: e.target.value })
        }
      ></TextArea>
      <Row>
        <Col>
          <Button
            style={{
              width: '5rem',
              backgroundColor: '#001529',
              color: 'white',
              marginTop: '10px',
            }}
            onClick={handleSave}
            disabled={!isValidInput() && workLog == null}
          >
            {workLog ? 'EDIT' : 'SAVE'}
          </Button>
        </Col>
      </Row>
    </Row>
  )
}

export default WorkLog
